export default __webpack_public_path__ + "9b8a8d9e488dfbcb345c46b891d5c31b.svg";